import { MapDeliveryJob } from "app/types/mapScreen";

export type MapJobMarkerGroup = {
  id: string;
  lat: number;
  lng: number;
  jobs: MapDeliveryJob[];
};

function getLocationKey(lat: number, lng: number): string {
  return `${lat.toFixed(6)}:${lng.toFixed(6)}`;
}

export function groupMapJobsByLocation(jobs: MapDeliveryJob[]): MapJobMarkerGroup[] {
  const groups = new Map<string, MapJobMarkerGroup>();

  for (const job of jobs) {
    const key = getLocationKey(job.lat, job.lng);
    const existing = groups.get(key);
    if (existing) {
      existing.jobs.push(job);
    } else {
      groups.set(key, {
        id: key,
        lat: job.lat,
        lng: job.lng,
        jobs: [job],
      });
    }
  }

  return Array.from(groups.values());
}

export function findGroupForJob(
  groups: MapJobMarkerGroup[],
  jobId: string
): MapJobMarkerGroup | undefined {
  return groups.find((group) => group.jobs.some((job) => job.id === jobId));
}

export function isGroupSelected(
  group: MapJobMarkerGroup,
  selectedJobIds: Set<string>
): boolean {
  return group.jobs.some((job) => selectedJobIds.has(job.id));
}

export function isGroupHighlighted(
  group: MapJobMarkerGroup,
  highlightedJobId: string | null
): boolean {
  if (!highlightedJobId) {
    return false;
  }
  return group.jobs.some((job) => job.id === highlightedJobId);
}
